<template>
    <div class="header-container">
        <el-header class="main-header">
            <div class="left-content">
                <!-- Logo区域 -->
                <div class="logo">
                    <img :src="$domainConfig.logo" alt="网站Logo" />
                    <!-- <span class="site-name">网站名称</span> -->
                </div>

                <!-- 桌面端导航菜单 -->
                <el-menu
                    v-if="!isMobile"
                    class="desktop-menu"
                    mode="horizontal"
                    :default-active="activeIndex"
                    background-color="#fff"
                    text-color="#333"
                    active-text-color="#409EFF"
                >
                    <el-menu-item
                        v-for="item in menuItems"
                        :key="item.path"
                        :index="item.path"
                        @click="navigateTo(item.path)"
                    >
                        {{ $t(item.title) }}
                    </el-menu-item>
                </el-menu>

                <!-- 移动端菜单按钮 -->
                <div v-else class="mobile-menu">
                    <!-- <el-button
                        type="text"
                        icon="el-icon-menu"
                        @click="drawerVisible = true"
                    ></el-button> -->
                    <i
                        class="fa fa-bars menu-toggle"
                        @click="drawerVisible = true"
                    ></i>
                </div>

                <!-- 移动端抽屉菜单 -->
                <el-drawer
                    title="菜单导航"
                    :visible.sync="drawerVisible"
                    direction="ltr"
                    :with-header="false"
                    size="60%"
                    :append-to-body="true"
                >
                    <el-menu
                        class="mobile-drawer-menu"
                        :default-active="activeIndex"
                        @select="handleMenuSelect"
                    >
                        <el-menu-item
                            v-for="item in menuItems"
                            :key="item.path"
                            :index="item.path"
                        >
                            <span>{{ $t(item.title) }}</span>
                        </el-menu-item>
                    </el-menu>
                </el-drawer>
            </div>
            <div class="right-content">
                <div class="user-info">
                    <el-button
                        type="text"
                        @click="logoutOpt"
                        v-if="token"
                        style="font-size: 16px"
                        >{{ $t('Logout') }}</el-button
                    >
                    <!-- <el-dropdown v-if="token">
                        <span class="el-dropdown-link">
                            <el-avatar
                                icon="el-icon-user-solid"
                                size="small"
                            ></el-avatar>
                            {{ username }}
                        </span>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item>个人中心</el-dropdown-item>
                            <el-dropdown-item>退出登录</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown> -->
                    <div v-else>
                        <el-button
                            type="text"
                            @click="login"
                            style="font-size: 16px"
                            >{{ $t('Login') }}</el-button
                        >
                    </div>
                </div>
                <el-dropdown trigger="click" @command="changeLanguage">
                    <span
                        class="language-switch"
                        style="font-size: 16px; cursor: pointer"
                    >
                        {{ selectedLocale }}<i class="el-icon-arrow-down"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item
                            v-for="item in languages"
                            :key="item.value"
                            :command="item.value"
                            >{{ item.label }}</el-dropdown-item
                        >
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
        </el-header>
    </div>
</template>

<script>
import { logout } from '@/api/user'
export default {
    name: 'MainHeader',
    data() {
        return {
            drawerVisible: false,
            isMobile: false,
            /* menuItems: [
                { title: 'Plans', path: '/' },
                { title: 'Account', path: '/account' },
                { title: 'Help', path: '/help' }
            ], */
            mobileMenuVisible: false,
            selectedLocale: '',
            languages: [
                { value: 'en', label: 'English' },
                { value: 'pt', label: 'Português' }
            ]
        }
    },
    computed: {
        activeIndex() {
            return this.$route.path
        },
        token() {
            return this.$store.state.token
        },
        menuItems() {
            if (this.token) {
                return [
                    { title: 'Plans', path: '/' },
                    { title: 'Account', path: '/account' },
                    { title: 'Partner', path: '/partner' },
                    { title: 'Help', path: '/help' }
                ]
            } else {
                return [
                    { title: 'Plans', path: '/' },
                    { title: 'Help', path: '/help' }
                ]
            }
        }
    },
    created() {
        this.checkMobile()
        window.addEventListener('resize', this.checkMobile)
        this.showLang(this.$i18n.locale)
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.checkMobile)
    },
    methods: {
        checkMobile() {
            this.isMobile = window.innerWidth < 768
            // console.log('isMobile:', this.isMobile)
        },
        navigateTo(path) {
            if (this.$route.path !== path) {
                this.$router.push(path)
            }
        },
        handleMenuSelect(path) {
            this.navigateTo(path)
            this.drawerVisible = false
        },
        showLang(value) {
            for (let i = 0; i < this.languages.length; i++) {
                if (this.languages[i].value == value) {
                    this.selectedLocale = this.languages[i].label
                }
            }
        },
        login() {
            this.$router.push('/login')
        },
        logoutOpt() {
            logout().then((res) => {
                if (res.code == 200) {
                    this.$store.dispatch('logout')
                } else {
                    console.log(res.message)
                }
            })
        },
        changeLanguage(command) {
            this.$i18n.locale = command
            this.showLang(command)
            localStorage.setItem('locale', command)
            this.$router.go(0)
        }
    }
}
</script>

<style scoped>
.header-container {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 1000;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}
.left-content {
    display: flex;
}
.right-content {
    display: flex;
    align-items: center;
}

.main-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 60px;
    background-color: #fff;
    padding: 0 20px;
}

.logo {
    display: flex;
    align-items: center;
    cursor: pointer;
}

.logo img {
    height: 40px;
    margin-right: 10px;
    border-radius: 8px;
}

.site-name {
    font-size: 20px;
    font-weight: bold;
    color: #333;
}

.desktop-menu {
    border-bottom: none;
    flex: 1;
    justify-content: flex-end;
    font-weight: 700;
}
.desktop-menu .el-menu-item {
    font-size: 18px;
}

.mobile-menu {
    display: flex;
    align-items: center;
}

.mobile-menu >>> .el-button {
    font-size: 24px;
    color: #333;
    padding: 0;
}

.mobile-drawer-menu {
    padding: 20px 0;
}
.user-info {
    margin-right: 10px;
}

/* 响应式处理 */
@media (max-width: 768px) {
    .main-header {
        padding: 0 10px;
    }

    .site-name {
        font-size: 16px;
    }

    .logo img {
        height: 30px;
    }
}
</style>